import { useEffect, useState } from 'react';

/** Tailwind `sm` breakpoint is 640px, so "mobile" is anything narrower. */
const MOBILE_QUERY = '(max-width: 639px)';

function read(): boolean {
  // jsdom/SSR has no matchMedia → default to the desktop layout. The header
  // gates which top-bar variant mounts on this value, and only one may mount
  // at a time (the cart registers itself as the single fly-to-cart target).
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(MOBILE_QUERY).matches;
}

/**
 * True when the viewport is at or below the `sm` breakpoint. Drives the
 * mobile-only header layout so a single set of action controls (cart, account,
 * language) is mounted per breakpoint rather than duplicated and CSS-hidden.
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(read);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(MOBILE_QUERY);
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  return isMobile;
}
